<script>import { EmptyData } from "../../icons/index.js";
import {
  createSvelteTable,
  flexRender,
  getCoreRowModel,
  getFilteredRowModel,
  getPaginationRowModel,
  getSortedRowModel
} from "@tanstack/svelte-table";
import { createEventDispatcher } from "svelte";
import { writable } from "svelte/store";
import Checkbox from "../Checkbox/Checkbox.svelte";
import Pagination from "../Pagination/Pagination.svelte";
import SortDownArrow from "../../icons/SortDownArrow.svelte";
import { cn } from "../../utils/twClnm.js";
export let defaultColumns = [];
export let defaultData = [];
export let current = 1;
export let page_size = 10;
export let limitOptions = [5, 10, 20, 50];
export let selectable = false;
export let selectAll = false;
export let dataCount = 0;
export let selectedRowIds = [];
export let tableClass = "";
export let paginationClass = "";
export let rowClass = "";
export let tabelParentClass = "";
export let isPaginationShow = true;
export let isLoading = false;
export let sortColumWritable;
export let onRowClick = void 0;
const dispatch = createEventDispatcher();
const pageSize = writable(page_size);
const currentPageNumber = writable(1);
const isSortOver = writable();
const options = writable({
  data: defaultData,
  columns: defaultColumns,
  enableRowSelection: false,
  enableSubRowSelection: true,
  getCoreRowModel: getCoreRowModel(),
  getSortedRowModel: getSortedRowModel(),
  getFilteredRowModel: getFilteredRowModel(),
  getPaginationRowModel: getPaginationRowModel(),
  debugAll: false,
  state: {
    pagination: {
      pageSize: $pageSize,
      pageIndex: 0
    }
  }
});
const isSorted = writable(false);
$: $options = {
  data: defaultData,
  columns: defaultColumns,
  enableRowSelection: false,
  enableSubRowSelection: true,
  getCoreRowModel: getCoreRowModel(),
  getSortedRowModel: getSortedRowModel(),
  getFilteredRowModel: getFilteredRowModel(),
  getPaginationRowModel: getPaginationRowModel(),
  debugAll: false,
  state: {
    pagination: {
      pageSize: $pageSize,
      pageIndex: 0
    }
  }
};
const table = createSvelteTable(options);
let page = writable(current);
$: {
  if ($options?.state?.pagination?.pageSize) {
    $options.state.pagination.pageSize = page_size;
  }
}
$: rowIds = $table.getRowModel().rows.map((row) => row.original.id);
$: selectAll = rowIds.length > 0 && rowIds.every((value) => selectedRowIds.includes(value));
$: totalPages = Math.ceil(dataCount / $pageSize);
function getSortSymbol(isSorted2) {
  return isSorted2 ? isSorted2 === "asc" ? "^" : "" : "";
}
function callGetData(data) {
  let pageLimit = +data.detail.pageLimit;
  let currentPage = +data.detail.currentPage;
  $pageSize = pageLimit;
  $currentPageNumber = currentPage;
  if (currentPage * pageLimit > dataCount + pageLimit) {
    currentPage = 1;
  }
  dispatch("toggle", {
    page_size: pageLimit,
    page_number: currentPage,
    selectedRowIds
  });
}
function handleSort(sortColum) {
  sortColumWritable.update(() => sortColum);
  dispatch("toggle", {
    page_size: $pageSize,
    page_number: $currentPageNumber,
    selectedRowIds,
    sortColum
  });
}
function checkBoxSelect() {
  dispatch("checkbox", { selectedRowIds });
}
let clickCount = 0;
function handleClick(header) {
  clickCount += 1;
  isSorted.update((val) => {
    if (clickCount % 3 === 1) {
      return true;
    } else if (clickCount % 3 === 2) {
      return false;
    } else {
      return void 0;
    }
  });
  handleSort({
    columnName: $isSorted === void 0 ? void 0 : header.column.id,
    isSorted: $isSorted
  });
}
$: if (current !== $page) {
  page.set(current);
}
</script>

<div
	class={cn(`tw-rounded ${$pageSize===dataCount? "tw-h-full" : " tw-h-[calc(100%-242px)]"}` , $$restProps.class)}
>
	<div
		class={cn("tw-relative tw-h-full tw-overflow-auto tw-border tw-border-solid tw-border-border tw-shadow-[0px_2px_4px_0px_rgba(0,0,0,0.08)]"
		, tabelParentClass)}
	>
		<table
			class={cn(` tw-w-full ${($table.getRowModel().rows.length == 0) ? "tw-h-full" : ""}`, tableClass)}
		>
			<thead class="tw-border-b tw-border-b-border">
				{#each $table.getHeaderGroups() as headerGroup}
					<tr>
						{#if selectable}
							<th
								class="tw-text tw-group tw-sticky tw-top-0 tw-z-10 tw-whitespace-nowrap tw-bg-light tw-p-3.5 tw-text-left tw-font-inter tw-text-base tw-font-semibold tw-leading-6"
							>
								<Checkbox
									name="select-row-{headerGroup.id}"
									value={selectAll ? headerGroup.id:""}
									group={selectAll ? [headerGroup.id] : []}
									on:change={(e) => {                     
										selectAll = !selectAll;

										selectedRowIds = !selectAll ? 
											 selectedRowIds.filter(item => !rowIds.includes(item)) : 
											 Array.from(new Set(selectedRowIds.concat($table.getRowModel().rows.map((row) => row.original.id))));
										
										checkBoxSelect()
									}}
								></Checkbox>
							</th>
						{/if}

						{#each headerGroup.headers as header}
							<th
								colSpan={header.colSpan}
								class={cn(`tw-text tw-group tw-sticky tw-top-0 
								tw-z-10 tw-whitespace-nowrap tw-bg-light 
								tw-p-3.5 tw-text-left tw-font-inter 
								tw-text-base tw-font-semibold tw-leading-6`,
								header.column.columnDef.meta?.class || '',
								header.column.columnDef.meta?.thClass || '')}
							>
								{#if header.column.getCanHide()}
									{#if !header.isPlaceholder}
										<!-- svelte-ignore a11y-mouse-events-have-key-events -->
										<button
											class="tw-button tw-is-white tw-flex tw-w-full tw-items-center tw-gap-3"
											class:is-disable={!header.column.getCanSort()}
											disabled={!header.column.getCanSort()}
											on:mouseover={() => {
												if (header.column.columnDef.enableSorting) {
													isSortOver.update(() => ({ colName: header.column.id, isSorted: true }));
												}
											}}
											on:mouseleave={() => {
												if (header.column.columnDef.enableSorting) {
													isSortOver.update(() => ({ colName: '', isSorted: false }));
												}
											}}
											on:click={() => handleClick(header)}
										>
											<div class="group tw-flex tw-w-full tw-items-center tw-justify-between">
												<svelte:component
													this={flexRender(header.column.columnDef.header, header.getContext())}
												/>
												<span class="tw-flex tw-h-5 tw-w-5 tw-items-center tw-justify-center">
													{#if $isSortOver?.colName === header.column.id && header.column.columnDef.enableSorting}
														<SortDownArrow className="tw-opacity-100" />
													{:else}
														<!-- Placeholder to maintain space -->
														<SortDownArrow className="tw-opacity-0" />
													{/if}
												</span>
											</div>
										</button>
									{/if}
								{/if}
							</th>
						{/each}
					</tr>
				{/each}
			</thead>
			<tbody class="tw-bg-white">
				{#if isLoading}
					{#each $table.getHeaderGroups() as headerGroup}
						{#each [1,2,3,4,5,6,7,8] as data}
							<tr
								class="bx--data-table--selected tw-border-b tw-border-primary/10 tw-transition-all tw-duration-100 tw-ease-in-out last:tw-border-b-0"
							>
								<th
									class={cn(`tw-relative tw-whitespace-nowrap tw-p-3.5
								tw-font-inter tw-text-sm tw-font-medium
								tw-leading-[21px] tw-text-dark`)}
								>
									<div class="tw-relative tw-h-7 tw-overflow-hidden tw-rounded tw-bg-[#f6f4f6]">
										<span
											class="tw-absolute tw-top-2/4 tw-h-[200%] tw-w-10 -tw-translate-y-2/4 -tw-skew-x-[25deg] tw-animate-skeleton tw-bg-white/70 tw-blur-lg"
										></span>
									</div>
								</th>
								{#each headerGroup.headers as header}
									<td
										class={cn(`tw-relative tw-whitespace-nowrap tw-p-3.5
								tw-font-inter tw-text-sm tw-font-medium
								tw-leading-[21px] tw-text-dark`)}
									>
										<div class="tw-relative tw-h-7 tw-overflow-hidden tw-rounded tw-bg-[#f6f4f6]">
											<span
												class="tw-absolute tw-top-2/4 tw-h-[200%] tw-w-10 -tw-translate-y-2/4 -tw-skew-x-[25deg] tw-animate-skeleton tw-bg-white/70 tw-blur-lg"
											></span>
										</div>
									</td>
								{/each}
							</tr>
						{/each}
					{/each}
				{:else if $table.getRowModel().rows.length>0}
					{#each $table.getRowModel().rows as row}
						<tr
							class="{selectedRowIds.includes(row.original.id)
						? 'bx--data-table--selected tw-border-primary/10  tw-bg-primary/10'
						: 'tw-border-border'} tw-border-b tw-transition-all tw-duration-100 tw-ease-in-out last:tw-border-b-0"
							on:click={row.getToggleSelectedHandler()}
						>
							{#if selectable}
								<td class={`tw-relative tw-whitespace-nowrap tw-p-3.5`}>
									<Checkbox
										labelClass="tw-text-neutral-800 tw-text-sm tw-font-normal tw-leading-tight"
										value={row.original.id}
										group={selectedRowIds}
										on:change={() =>{
										if((selectedRowIds.includes(row.original.id)))	{
											selectedRowIds = selectedRowIds.filter(
												(id) => id !== row.original.id
											);
										}else{
											selectedRowIds = [...selectedRowIds, row.original.id];
										}
                  						  checkBoxSelect()
              						}}
									></Checkbox>
								</td>
							{/if}

							{#each row.getVisibleCells() as cell}
								<td
									class={cn(`tw-relative tw-whitespace-nowrap tw-p-3.5
								tw-font-inter tw-text-sm tw-font-medium 
								${cell.column.columnDef.meta?.clickable && 'tw-cursor-pointer'}
								tw-leading-[21px] tw-text-dark`, rowClass, 
								cell.column.columnDef.meta?.class || '',
								cell.column.columnDef.meta?.tdClass || 	''
								)}
									on:click={(e) => {									
									if (onRowClick && cell.column.columnDef.meta?.clickable) {
										const headerName = cell.column.columnDef.meta?.headerName || cell.column.id;	
										onRowClick({...row, original: {...row.original, headerName}});
									}
								}}
								>
									<svelte:component
										this={flexRender(cell.column.columnDef.cell, cell.getContext())}
									/>
								</td>
							{/each}
						</tr>
					{/each}
				{:else}
					<tr class="">
						<td colspan={defaultColumns.length + 1}>
							<div class="relative text-center tw-my-5">
								<div class="tw-mx-auto tw-inline-block">
									<EmptyData />
								</div>
								<div>No Data</div>
							</div>
						</td>
					</tr>
				{/if}
			</tbody>
		</table>
	</div>

	{#if isPaginationShow && $table.getRowModel().rows?.length > 0}
		<div
			class={cn("tw-border-bor-light/60 tw-items-center tw-justify-center tw-border-t tw-px-5 tw-py-5", paginationClass)}
		>
			<Pagination
				currentPage={page}
				pageLimit={pageSize}
				limitOptions={limitOptions}
				totalItems={dataCount}
				totalPages={totalPages}
				on:toggle={callGetData}
			></Pagination>
		</div>
	{/if}
</div>
